import { Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { AuthGuard } from 'app/guards/auth-guard.service';

export const LoginRoutes: Routes = [
    { path: 'login', component: LoginComponent, data:{title : 'Login'}},
];
export class LoginModule {

}